var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "meta-background",
      class: { "special-background": _vm.specialBackgroundMode },
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "48px",
        height: "48px",
      },
    },
    [
      _c("path", {
        attrs: {
          fill: "#0081fb",
          d: "M47,29.36l-2.193,1.663L42.62,29.5c0-0.16,0-0.33-0.01-0.5c0-0.16,0-0.33-0.01-0.5\tc-0.14-3.94-1.14-8.16-3.14-11.25c-1.54-2.37-3.51-3.5-5.71-3.5c-2.31,0-4.19,1.38-6.27,4.38c-0.06,0.09-0.13,0.18-0.19,0.28\tc-0.04,0.05-0.07,0.1-0.11,0.16c-0.1,0.15-0.2,0.3-0.3,0.46c-0.9,1.4-1.84,3.03-2.86,4.83c-0.09,0.17-0.19,0.34-0.28,0.51\tc-0.03,0.04-0.06,0.09-0.08,0.13l-0.21,0.37l-1.24,2.19c-2.91,5.15-3.65,6.33-5.1,8.26C14.56,38.71,12.38,40,9.51,40\tc-3.4,0-5.56-1.47-6.89-3.69C1.53,34.51,1,32.14,1,29.44l4.97,0.17c0,1.76,0.38,3.1,0.89,3.92C7.52,34.59,8.49,35,9.5,35\tc1.29,0,2.49-0.27,4.77-3.43c1.83-2.53,3.99-6.07,5.44-8.3l1.37-2.09l0.29-0.46l0.3-0.45l0.5-0.77c0.76-1.16,1.58-2.39,2.46-3.57\tc0.1-0.14,0.2-0.28,0.31-0.42c0.1-0.14,0.21-0.28,0.31-0.41c0.9-1.15,1.85-2.22,2.87-3.1c1.85-1.61,3.84-2.5,5.85-2.5\tc3.37,0,6.58,1.95,9.04,5.61c2.51,3.74,3.82,8.4,3.97,13.25c0.01,0.16,0.01,0.33,0.01,0.5C47,29.03,47,29.19,47,29.36z",
        },
      }),
      _vm._v(" "),
      _c(
        "linearGradient",
        {
          attrs: {
            id: "wSMw7pqi7WIWHewz2_TZXa",
            x1: "42.304",
            x2: "13.533",
            y1: "24.75",
            y2: "24.75",
            gradientUnits: "userSpaceOnUse",
          },
        },
        [
          _c("stop", { attrs: { offset: "0", "stop-color": "#0081fb" } }),
          _vm._v(" "),
          _c("stop", { attrs: { offset: ".995", "stop-color": "#0064e1" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "url(#wSMw7pqi7WIWHewz2_TZXa)",
          d: "M4.918,15.456\tC7.195,11.951,10.483,9.5,14.253,9.5c2.184,0,4.354,0.645,6.621,2.493c2.479,2.02,5.122,5.346,8.419,10.828l1.182,1.967\tc2.854,4.746,4.477,7.187,5.428,8.339C37.125,34.606,37.888,35,39,35c2.82,0,3.617-2.54,3.617-5.501L47,29.362\tc0,3.095-0.611,5.369-1.651,7.165C44.345,38.264,42.387,40,39.093,40c-2.048,0-3.862-0.444-5.868-2.333\tc-1.542-1.45-3.345-4.026-4.732-6.341l-4.126-6.879c-2.07-3.452-3.969-6.027-5.068-7.192c-1.182-1.254-2.642-2.754-5.067-2.754\tc-1.963,0-3.689,1.362-5.084,3.465L4.918,15.456z",
        },
      }),
      _vm._v(" "),
      _c(
        "linearGradient",
        {
          attrs: {
            id: "wSMw7pqi7WIWHewz2_TZXb",
            x1: "7.635",
            x2: "7.635",
            y1: "32.87",
            y2: "13.012",
            gradientUnits: "userSpaceOnUse",
          },
        },
        [
          _c("stop", { attrs: { offset: "0", "stop-color": "#0081fb" } }),
          _vm._v(" "),
          _c("stop", { attrs: { offset: ".995", "stop-color": "#0064e1" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "url(#wSMw7pqi7WIWHewz2_TZXb)",
          d: "M14.25,14.5\tc-1.959,0-3.683,1.362-5.075,3.465C7.206,20.937,6,25.363,6,29.614c0,1.753-0.003,3.072,0.5,3.886l-3.84,2.813\tC1.574,34.507,1,32.2,1,29.5c0-4.91,1.355-10.091,3.918-14.044C7.192,11.951,10.507,9.5,14.27,9.5L14.25,14.5z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M21.67,20.27l-0.3,0.45l-0.29,0.46c0.71,1.03,1.52,2.27,2.37,3.69l0.21-0.37c0.02-0.04,0.05-0.09,0.08-0.13 c0.09-0.17,0.19-0.34,0.28-0.51C23.19,22.5,22.39,21.29,21.67,20.27z M24.94,15.51c-0.11,0.14-0.21,0.28-0.31,0.42 c0.73,0.91,1.47,1.94,2.25,3.1c0.1-0.16,0.2-0.31,0.3-0.46c0.04-0.06,0.07-0.11,0.11-0.16c0.06-0.1,0.13-0.19,0.19-0.28 c-0.76-1.12-1.5-2.13-2.23-3.03C25.15,15.23,25.04,15.37,24.94,15.51z",
          opacity: ".05",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M21.67,20.27l-0.3,0.45c0.71,1.02,1.51,2.24,2.37,3.65c0.09-0.17,0.19-0.34,0.28-0.51C23.19,22.5,22.39,21.29,21.67,20.27 z M24.63,15.93c0.73,0.91,1.47,1.94,2.25,3.1c0.1-0.16,0.2-0.31,0.3-0.46c-0.77-1.14-1.52-2.16-2.24-3.06 C24.83,15.65,24.73,15.79,24.63,15.93z",
          opacity: ".07",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }